import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

import {
  IAPI_CON001_Request,
  IAPI_CON001_Response,
  IAPI_REC001_Request,
  IAPI_REC001_Response,
  IAPI_REC006_Request,
  IAPI_REC006_Response,
  IAPI_REC007_Request,
  IAPI_REC007_Response,
  IAPI_REC026_Response,
} from "../../../type/apiType";

// 請求実績参照API
const httpAPI_REC026 = async (): Promise<IAPI_REC026_Response> => {
  let res = await http.post(ApiUrl.API_REC026, {});

  return res.data;
};

// 契約者一覧参照
const httpAPI_CON001 = async (
  param: IAPI_CON001_Request
): Promise<IAPI_CON001_Response> => {
  const res = await http.post(ApiUrl.API_CON001, {
    ...param,
  });
  return res.data;
};

// 入金・請求一覧参照API
const httpAPI_REC001 = async (
  param: IAPI_REC001_Request
): Promise<IAPI_REC001_Response> => {
  const res = await http.post(ApiUrl.API_REC001, {
    ...param,
  });
  return res.data;
};

// 不着明細取込参照API
const httpAPI_REC007 = async (
  param: IAPI_REC007_Request
): Promise<IAPI_REC007_Response> => {
  let res = await http.post(ApiUrl.API_REC007, {
    ...param,
  });

  return res.data;
};

// 入金帳票取込参照API
const httpAPI_REC006 = async (
  param: IAPI_REC006_Request
): Promise<IAPI_REC006_Response> => {
  let res = await http.post(ApiUrl.API_REC006, {
    ...param,
  });

  return res.data;
};

export {
  httpAPI_REC001,
  httpAPI_REC006,
  httpAPI_REC007,
  httpAPI_REC026,
  httpAPI_CON001,
};
